/* ==========================================================
   CONFIGURATION DU SITE MOUCH'PABA
   Le contenu "coureurs" et "événements" est saisi dans le Google Sheet :
   https://docs.google.com/spreadsheets/d/1FGnJs8UiwQ6LuR1EJUKycwfIPXq5pcDspU2_BkGwTYM
   (partage : "Toute personne disposant du lien" -> Lecteur)
   ========================================================== */

export const SHEET_ID = "1FGnJs8UiwQ6LuR1EJUKycwfIPXq5pcDspU2_BkGwTYM";

// Noms exacts des onglets du Google Sheet
export const SHEET_TABS = {
    coureurs: "Coureurs",
    evenements: "Evenements",
};

// Course mise en avant (accueil + page Course).
// Une ligne de l'onglet "Evenements" avec "Mise en avant = oui" remplace ces valeurs.
export const FEATURED_RACE = {
    title: "FIS & Children Telemark",
    subtitle: "Children / FIS / Mouch'Paba Open – sprint le samedi, classique le dimanche",
    dateStart: "2027-01-30",
    dateEnd: "2027-01-31",
    place: "", // ex. "Les Masses" – à compléter
    image: process.env.PUBLIC_URL + "/images/course2027/hero.jpg",
    link: "https://www.fis-ski.com/DB/general/event-details.html?sectorcode=TM&eventid=63112&seasoncode=2027",
};

export const CONTACT_MAIL = "info@mouchpaba.ch";
export const INSTAGRAM = "https://www.instagram.com/telemarkworldcupthyon/";
export const FACEBOOK = "https://www.facebook.com/telemarkworldcupthyon";
